import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getTicketRemainingTextStyles } from 'common/entities/form/styleConfiguration/selectors';
import {
    setTicketRemainingTextFont,
    setTicketRemainingTextFontsize,
    setTicketRemainingTextColor,
} from 'common/entities/form/styleConfiguration/actions';
import { getDefaultStyle, styleShapePropTypes } from 'common/entities/form/styleConfiguration/utils';
import {
    DEFAULT_FONT,
    DEFAULT_TICKET_FONT_SIZE,
    DEFAULT_TICKET_REMAINING_COLOR,
} from 'common/entities/form/styleConfiguration/defaultValues';
import DefaultFontTicketStylePanel from './DefaultFontTicketStylePanel';
import { getFormId, getOpenTicketStylingType } from '../../../../selectors';
import { REMAINING_QA } from '../../../../constants/ticketDataQa';
import { REMAINING_TICKET_LABEL } from '../../../../constants/formStyleLabels';

const FormStyleTicketEditorRemainingPanel = (props) => (
    <DefaultFontTicketStylePanel
        ticketPanelQaId={REMAINING_QA}
        setTicketPanelFontFamily={props.setTicketRemainingTextFont}
        setTicketPanelFontSize={props.setTicketRemainingTextFontsize}
        setTicketPanelTextColor={props.setTicketRemainingTextColor}
        {...props}
        componentLabel={REMAINING_TICKET_LABEL}
    />
);

FormStyleTicketEditorRemainingPanel.propTypes = {
    formId: PropTypes.string.isRequired,
    color: styleShapePropTypes,
    font: styleShapePropTypes,
    fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    setTicketRemainingTextFont: PropTypes.func.isRequired,
    setTicketRemainingTextFontsize: PropTypes.func.isRequired,
    setTicketRemainingTextColor: PropTypes.func.isRequired,
};

FormStyleTicketEditorRemainingPanel.defaultProps = {
    color: getDefaultStyle(DEFAULT_TICKET_REMAINING_COLOR),
    font: getDefaultStyle(DEFAULT_FONT),
    fontSize: DEFAULT_TICKET_FONT_SIZE,
};

const mapStateToProps = (state) => {
    const formId = getFormId(state);
    const openTicketType = getOpenTicketStylingType(state);

    const { color, font, fontSize } = getTicketRemainingTextStyles(state, formId, openTicketType);

    return {
        formId,
        color,
        font,
        fontSize,
    };
};

const mapDispatchToProps = {
    setTicketRemainingTextFont,
    setTicketRemainingTextFontsize,
    setTicketRemainingTextColor,
};

export default connect(mapStateToProps, mapDispatchToProps)(FormStyleTicketEditorRemainingPanel);
